import React, { useEffect, useState } from "react";
import Button from "../../shared/Button";
import add from "../../../assets/img/icons/add.svg";
import { Checkbox } from "antd";
import useFetch from "../../../hooks/useAxios";
import { useCreatePlace } from "../../../context/CreatePlaceContext";
import CounterWithlabelin from "../../shared/CounterWithlabelin";
import AddFunModal from "./Modal/AddFunModal";
import AddCoolerModal from "./Modal/AddCoolerModal";
import AddHeatModal from "./Modal/AddHeatModal";
import AddKitchenModal from "./Modal/AddKitchenModal";
import { toast } from "react-hot-toast";
import { useParams } from "react-router-dom";

const CreateStep6 = ({prevStep,nextStep}) => {
  const { updatePlaceDetail, createInfoData ,apiUpdateResideces,setIsEditPlaceCompleter} = useCreatePlace();

  const [restroom, setrestroom] = useState(0);
  const [kharejibathroom, setkharejibathroom] = useState(0);
  const [parking, setparking] = useState(0);
  const [emkrefahi, setemkrefahi] = useState([]);
  const [emkfun, setemkfun] = useState([]);
  const [emkfunModal, setemkfunModal] = useState(false);
  const [CustomFunList, setCustomFunList] = useState([]);
  const [emkCoolerModal, setemkCoolerModal] = useState(false);
  const [CustomCoolerList, setCustomCoolerList] = useState([]);
  const [emkHeatModal, setemkHeatModal] = useState(false);
  const [CustomHeatList, setCustomHeatList] = useState([]);
  const [emkKitchenModal, setemkKitchenModal] = useState(false);
  const [CustomKitchenList, setCustomKitchenList] = useState([]);
  const [emksarmayesh, setemksarmayesh] = useState([]);
  const [emkgarmaysh, setemkgarmaysh] = useState([]);
  const [emkimeni, setemkimeni] = useState([]);
  const [kitchen, setkitchen] = useState([]);
  useEffect(() => {
    setemkrefahi(createInfoData.stepSeven.facilities.welfare)
    setemkfun(createInfoData.stepSeven.facilities.sport)
    setemkgarmaysh(createInfoData.stepSeven.facilities.heating)
    setemksarmayesh(createInfoData.stepSeven.facilities.cooling)
    setkitchen(createInfoData.stepSeven.facilities.kitchen)
    setemkimeni(createInfoData.stepSeven.facilities.safety)
    setCustomFunList(createInfoData.stepSeven.custom_facilities.sport)
    setCustomHeatList(createInfoData.stepSeven.custom_facilities.heating)
    setCustomKitchenList(createInfoData.stepSeven.custom_facilities.kitchen)
    setCustomCoolerList(createInfoData.stepSeven.custom_facilities.cooling)
    }, [createInfoData])

  const [facilities, setFacilities] = useState();
  const apifacilities = useFetch({
    method: "get",
    url: "api/facilities",
    noHeader: false,
    trigger: true,

    argFunc: res => {
      
      setFacilities(res.data);
      //  console.log(JSON.parse(typeResidence))
    }
  });
  const gotonext = () => {

    if(emkrefahi.length === 0){
      toast.error("امکانات رفاهی اجباری است")
    }else if(emkgarmaysh.length === 0){
      toast.error("امکانات گرمایشی اجباری است")
    }else if(emksarmayesh.length === 0){
      toast.error("امکانات سرمایشی اجباری است")
    }else {
      updatePlaceDetail("stepSeven", {
         parkingCount:parking,
         bathroom:kharejibathroom,
         restroom:restroom,
         custom_facilities:{
          welfare: [],
          sport: CustomFunList,
          heating: CustomHeatList,
          cooling: CustomCoolerList,
          kitchen: CustomKitchenList,
          safety:[]
         },
       facilities: {
          welfare: emkrefahi,
          sport: emkfun,
          heating: emkgarmaysh,
          cooling: emksarmayesh,
          kitchen: kitchen,
          safety:emkimeni
        }
      });
     nextStep()
    }
   
  };
  const {id}=useParams()
  const update = (data) => {
    if(emkrefahi.length === 0){
      toast.error("امکانات رفاهی اجباری است")
    }else if(emkgarmaysh.length === 0){
      toast.error("امکانات گرمایشی اجباری است")
    }else if(emksarmayesh.length === 0){
      toast.error("امکانات سرمایشی اجباری است")
    }else {
      updatePlaceDetail("stepSeven", {
         parkingCount:parking,
         bathroom:kharejibathroom,
         restroom:restroom,
         custom_facilities:{
          welfare: [],
          sport: CustomFunList,
          heating: CustomHeatList,
          cooling: CustomCoolerList,
          kitchen: CustomKitchenList,
          safety:[]
         },
       facilities: {
          welfare: emkrefahi,
          sport: emkfun,
          heating: emkgarmaysh,
          cooling: emksarmayesh,
          kitchen: kitchen,
          safety:emkimeni
        }
      });
       setIsEditPlaceCompleter(true);
    
      }
  };
  return (
    <div className="createsteps">
      {" "}<h2>امکانات رفاهی</h2>
      <p className="w-[100%] ">
        اولین و مهم‌ترین امکاناتی که مهمان‌ها در هنگام مقایسه و انتخاب اقامتگاه
        به آن‌ها توجه خواهند .
      </p>
      <h4 className="mt-[50px] text-[#292D32] text-[18px] text-[700]">
        امکانات رفاهی
      </h4>
    {facilities &&
      <div>
          <div className="createsteps-grid-4 mt-[6px]">
        {facilities?.welfare[0].map((i,index) =>
          <button
            onClick={() => {
              if (emkrefahi.filter(e => e.value === i.value).length > 0) {
                setemkrefahi(emkrefahi.filter(j => i.value !== j.value));
              } else {
                setemkrefahi(prev => [...prev, {...i}]);
              }
            }}
            className={`createsteps-box ${(emkrefahi.filter(e => e.value === i.value).length > 0)
              ? "createsteps-box--active"
              : ""}`}
          >
            {i.label}
          </button>
        )}
      </div>
      <div className="createsteps--grid3 mt-[50px]">
        {
           emkrefahi.filter(i=>i.value === "iranian_wc").length !==0 && 
           <CounterWithlabelin
           label="تعداد توالت ایرانی"
           count={restroom}
           setCount={setrestroom}
           labelin="مورد"
         />
        }
       
        {
          emkrefahi.filter(i=>i.value === "bathroom").length !==0 && 
          <CounterWithlabelin
          label="تعدادحمام"
          count={kharejibathroom}
          setCount={setkharejibathroom}
          labelin="مورد"
        />
        }
        
      {emkrefahi.filter(i=>i.value === "parking").length !==0 &&  <CounterWithlabelin
          label="تعداد پارکینگ "
          count={parking}
          setCount={setparking}
          labelin="مورد"
        />}

      </div>
      <h4 className="mt-[50px] text-[#292D32] text-[18px] text-[700]">
      امکانات سرگرمی
      </h4>
      <div className="createsteps-grid-4 mt-[6px]">
        {facilities?.sport.map(i =>
          <button
            onClick={() => {
              if (emkfun.filter(e => e.value === i.value).length > 0) {
                setemkfun(emkfun.filter(j => i.value !== j.value));
              } else {
                setemkfun(prev => [...prev, {...i}]);
              }
            }}
            className={`createsteps-box ${emkfun.filter(e => e.value === i.value).length > 0
              ? "createsteps-box--active"
              : ""}`}
          >
            {i.label}
          </button>
        )}
        {
        CustomFunList.map(i=>
          <button
          onClick={() => {
            if (CustomFunList.filter(e => e.value === i.value).length > 0) {
              setCustomFunList(CustomFunList.filter(j => i.value !== j.value));
            } else {
              setCustomFunList(prev => [...prev, {...i}]);
            }
          }}
          className={`createsteps-box ${CustomFunList.filter(e => e.value === i.value).length > 0
            ? "createsteps-box--active"
            : ""}`}
        >
          {i.value}
        </button>
          )
        }
      </div>
      <Button varient="borderbot" className="mt-[20px]" onClick={()=>setemkfunModal(true)}>
        <div className="flex items-center gap-[5px]">
          <img src={add} />
          <div> افزودن مورد جدید</div>
        </div>
      </Button>
      <h4 className="mt-[50px] text-[#292D32] text-[18px] text-[700]">
      سیستم سرمایشی
      </h4>
      <div className="createsteps-grid-4 mt-[6px]">
        {facilities?.cooling.map(i =>
          <button
            onClick={() => {
              if (emksarmayesh.filter(e => e.value === i.value).length > 0) {
                setemksarmayesh(emksarmayesh.filter(j => i.value !== j.value));
              } else {
                setemksarmayesh(prev => [...prev, {...i}]);
              }
            }}
            className={`createsteps-box ${emksarmayesh.filter(e => e.value === i.value).length > 0
              ? "createsteps-box--active"
              : ""}`}
          >
            {i.label}
          </button>
        )}
        {
        CustomCoolerList.map(i=>
          <button
          onClick={() => {
            if (CustomCoolerList.filter(e => e.value === i.value).length > 0) {
              setCustomCoolerList(CustomCoolerList.filter(j => i.value !== j.value));
            } else {
              setCustomCoolerList(prev => [...prev, {...i}]);
            }
          }}
          className={`createsteps-box ${CustomCoolerList.filter(e => e.value === i.value).length > 0
            ? "createsteps-box--active"
            : ""}`}
        >
          {i.value}
        </button>
          )
        }
      </div>
      <Button varient="borderbot" className="mt-[20px]" onClick={()=>setemkCoolerModal(true)}>
        <div className="flex items-center gap-[5px]">
          <img src={add} />
          <div> افزودن مورد جدید</div>
        </div>
      </Button>
      <h4 className="mt-[50px] text-[#292D32] text-[18px] text-[700]">
      سیستم گرمایشی
      </h4>
      <div className="createsteps-grid-4 mt-[6px]">
        {facilities?.heating.map(i =>
          <button
            onClick={() => {
              if (emkgarmaysh.filter(e => e.value === i.value).length > 0) {
                setemkgarmaysh(emkgarmaysh.filter(j => i.value !== j.value));
              } else {
                setemkgarmaysh(prev => [...prev, {...i}]);
              }
            }}
            className={`createsteps-box ${emkgarmaysh.filter(e => e.value === i.value).length > 0
              ? "createsteps-box--active"
              : ""}`}
          >
            {i.label}
          </button>
        )}
         {
        CustomHeatList.map(i=>
          <button
          onClick={() => {
            if (CustomHeatList.filter(e => e.value === i.value).length > 0) {
              setCustomHeatList(CustomHeatList.filter(j => i.value !== j.value));
            } else {
              setCustomHeatList(prev => [...prev, {...i}]);
            }
          }}
          className={`createsteps-box ${CustomHeatList.filter(e => e.value === i.value).length > 0
            ? "createsteps-box--active"
            : ""}`}
        >
          {i.value}
        </button>
          )
        }
      </div>
      <Button varient="borderbot" className="mt-[20px]"  onClick={()=>setemkHeatModal(true)}>
        <div className="flex items-center gap-[5px]">
          <img src={add} />
          <div> افزودن مورد جدید</div>
        </div>
      </Button>
      <h4 className="mt-[50px] text-[#292D32] text-[18px] text-[700]">
      امکانات ایمنی
      </h4>
      <div className="createsteps-grid-4 mt-[6px]">
        {facilities?.safety.map(i =>
          <button
            onClick={() => {
              if (emkimeni.filter(e => e.value === i.value).length > 0) {
                setemkimeni(emkimeni.filter(j => i.value !== j.value));
              } else {
                setemkimeni(prev => [...prev, {...i}]);
              }
            }}
            className={`createsteps-box ${emkimeni.filter(e => e.value === i.value).length > 0
              ? "createsteps-box--active"
              : ""}`}
          >
            {i.label}
          </button>
        )}
      </div>
      <h4 className="mt-[50px] text-[#292D32] text-[18px] text-[700]">
      امکانات آشپزخانه
      </h4>
      <div className="createsteps-grid-4 mt-[6px]">
   {   facilities?.kitchen.map(i =>
             <button
             onClick={() => {
               if (kitchen.filter(e => e.value === i.value).length > 0) {
                 setkitchen(kitchen.filter(j => i.value !== j.value));
               } else {
                 setkitchen(prev => [...prev, {...i}]);
               }
             }}
             className={`createsteps-box ${kitchen.filter(e => e.value === i.value).length > 0
               ? "createsteps-box--active"
               : ""}`}
           >
             {i.label}
           </button>
          )}
           {
        CustomKitchenList.map(i=>
          <button
          onClick={() => {
            if (CustomKitchenList.filter(e => e.value === i.value).length > 0) {
              setCustomKitchenList(CustomKitchenList.filter(j => i.value !== j.value));
            } else {
              setCustomKitchenList(prev => [...prev, {...i}]);
            }
          }}
          className={`createsteps-box ${CustomKitchenList.filter(e => e.value === i.value).length > 0
            ? "createsteps-box--active"
            : ""}`}
        >
          {i.value}
        </button>
          )
        }
      </div>
      </div>
    }
      <Button varient="borderbot" className="mt-[20px]" onClick={()=>setemkKitchenModal(true)}>
        <div className="flex items-center gap-[5px]">
          <img src={add} />
          <div> افزودن مورد جدید</div>
        </div>
      </Button>
      <div className="flex create-box--button justify-end gap-[16px] w-[full] mt-[70px]">
    { id&& <Button varient="primary" onClick={()=>update()}> 
                بروزرسانی اقامتگاه
              </Button>}
       <Button
                varient="gray"
                onClick={() => {
                  prevStep()
                }}
              >
                مرحله قبلی
              </Button> 

              <Button varient="primary" onClick={()=>gotonext()}>
                  مرحله بعدی
              </Button>
            </div>
      
    {
      emkfunModal && <AddFunModal closeModal={()=>setemkfunModal(false)} setcustomSleep={setCustomFunList} customSleep={CustomFunList}/>
    }
      {
      emkCoolerModal && <AddCoolerModal closeModal={()=>setemkCoolerModal(false)} setcustomSleep={setCustomCoolerList} customSleep={CustomCoolerList}/>
    }
      {
      emkHeatModal && <AddHeatModal closeModal={()=>setemkHeatModal(false)} setcustomSleep={setCustomHeatList} customSleep={CustomHeatList}/>
    }
    {
      emkKitchenModal && <AddKitchenModal closeModal={()=>setemkKitchenModal(false)} setcustomSleep={setCustomKitchenList} customSleep={CustomKitchenList}/>
    }
    </div>
  );
};

export default CreateStep6;
